import { render, staticRenderFns } from "./merchants.vue?vue&type=template&id=9f3b4dce&scoped=true&"
import script from "./merchants.vue?vue&type=script&lang=js&"
export * from "./merchants.vue?vue&type=script&lang=js&"
import style0 from "./merchants.vue?vue&type=style&index=0&lang=css&"
import style1 from "./merchants.vue?vue&type=style&index=1&id=9f3b4dce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3b4dce",
  null
  
)

export default component.exports